import React from 'react';
import Icon from './Icon';

const CloseIcon = (props) => (
    <Icon {...props}>
        <path
            d="M9 9L15 15M15 9L9 15M9.5 2.4A10 10 0 1 1 2.4 9.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);

export default CloseIcon;